<template>
  <div>
    <v-menu offset-y>
      
      <template v-slot:activator="{ on }">
        <div v-on="on" class="header-item user-image"
          @click="gaClick('accountMenu_btn_open')">
          <img v-if="user_image_existed" :style="{'border-color': color}" :src="user_image">
          <div v-else id="no-image" :style="{'border-color': color}">
            <v-icon id="no-image-icon">mdi-account</v-icon>
          </div>
        </div>
      </template>

      <v-list dense>

        <v-list-item>
          <v-list-item-title>{{ email }}</v-list-item-title>
        </v-list-item>

        <v-list-item v-if="!!user_type">
          <v-list-item-content>
            <span class="menu">
              <div class="badge" :style="{'background-color': color}"></div>
              <span>{{ $t('account_modal.'+user_type) }}</span>
              <span v-if="is_auto_payments&&user_type!='trial'&&user_type!='basic'">(매월)</span>
              <span v-if="!is_permanent&&user_type!='basic'">
                <span>|</span>
                <span>{{ $t('account_modal.to', [end_date])}}</span>
                <span>(D-{{ date_diff }})</span>
              </span>
            </span>
          </v-list-item-content>
        </v-list-item>

        <router-link v-if="!is_permanent&&!is_cashwait&&!is_auto_payments"
          tag="v-list-item"
          :to="{ name: 'signup' }">
          <v-btn dark small block outlined class="primary">
            <v-icon small>mdi-crown</v-icon>
            {{ $t('account_modal.subscribe') }}
          </v-btn>
        </router-link>

        <v-list-item v-if="is_auto_payments&&user_type=='basic'" >
          <v-btn @click="change_dialog=true"
            small block outlined dark class="primary">
            결제 정보 변경하기
          </v-btn>
        </v-list-item>

        <v-list-item v-if="is_cashwait">
          <v-btn @click="cashwait_dialog=true"
            small block outlined dark class="primary">
            결제 대기 중
          </v-btn>
        </v-list-item>

        <v-divider></v-divider>

        <router-link
          tag="v-list-item"
          :to="{ name: 'account' }">
          <v-list-item-title>{{ $t("account_modal.account") }}</v-list-item-title>
        </router-link>

        <v-list-item @click="report_issue_visible=true;gaClick('accountMenu_btn_report')">
          <v-list-item-title>{{ $t("account_modal.report_an_issue") }}</v-list-item-title>
        </v-list-item>

        <router-link
          tag="v-list-item"
          :to="{ name: 'issues' }">
          <v-list-item-title>{{ $t("account_modal.my_requests") }}</v-list-item-title>
        </router-link>

        <router-link
          tag="v-list-item"
          :to="{ name: 'guide' }">
          <v-list-item-title>{{ $t("account_modal.user_guide") }}(리뉴얼중)</v-list-item-title>
        </router-link>

        <router-link
          tag="v-list-item"
          :to="{ name: 'whats-new' }">
          <v-list-item-title>{{ $t("account_modal.what_s_new_in_bt") }}</v-list-item-title>
        </router-link>

        <v-divider></v-divider>

        <v-list-item link @click="logout()">
          <v-list-item-title>{{ $t("account_modal.sign_out") }}</v-list-item-title>
        </v-list-item>

      </v-list>
    </v-menu>

    <!-- Modal -->
    <modal-report-issue
      :dialog.sync="report_issue_visible">
    </modal-report-issue>

    <!-- Modal cashwait -->
    <template>
      <v-dialog v-model="cashwait_dialog" width="400px">
        <v-card>
          <v-card-title>결제 대기 중인 상품이 있습니다.</v-card-title>
          <v-card-text>
            <div class="meta" v-for="cw in cashwaits" :key="cw.pay_id">
              <span>상품: </span>
              <span>{{ $t('plans.' + cw.product_name) }}</span>
              <span>&nbsp;|&nbsp;</span>
              <span>금액: </span>
              <span>{{ cw.amount }}</span>
            </div>
            <div class="meta">
              결제를 완료하시려면 해당 금액을 100-033-372182 (신한은행, 예금주: 비블리오트리즈주식회사)로 입금해주세요. <br>
              결제 요청을 취소하시려면 <a href="mailto: services@bibliotrees.net">문의</a>로 알려주세요.
            </div>
          </v-card-text>
          <v-card-actions class="actions">
            <v-spacer></v-spacer>
            <v-btn small text @click="cashwait_dialog=false">
              {{ $t('actions.close') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

    <!-- Modal change -->
    <template>
      <v-dialog v-model="change_dialog" width="400px">
        <v-card>
          <v-card-title>결제 정보를 변경해주세요!</v-card-title>
          <v-card-text>
            <div class="meta">
              프리미엄 이용권 결제 정보에 문제가 있어 알려드립니다.<br>
              '계정' 페이지에서 정보를 업데이트하시거나, 동일한 페이지에서 이용권을 해지하시고 다시 구독해주세요. <br>
              다른 문제가 있을 경우 <a href="mailto: services@bibliotrees.net">문의</a>로 알려주세요.
            </div>
          </v-card-text>
          <v-card-actions class="actions">
            <v-spacer></v-spacer>
            <v-btn small text @click="change_dialog=false">
              {{ $t('actions.close') }}
            </v-btn>
            <router-link tag="div" :to="{name: 'account'}">
              <v-btn small block depressed color="primary">
                계정 페이지로 이동하기
              </v-btn>
            </router-link>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

  </div>

</template>

<script>
import { mapGetters } from 'vuex'
import { toDatetimeLocal, getDDay } from '../../../custom/function.js'
import { user_types } from '../../../custom/model.js'

export default {
  data() {
    return {
      user_types,
      report_issue_visible: false,
      cashwait_dialog: false,
      change_dialog: false,
    }
  },

  computed: {
    ...mapGetters({
      user_image: 'user/user_image',
      user_image_existed: 'user/image_existed',
      user_payments: 'user/payments',
      user_end_date: 'user/end_date',
      email: 'user/email',
      auto_payments: 'user/auto_payments',
      user_type: 'user/user_type',
      is_permanent: 'user/is_permanent',
      is_expired: 'auth/is_expired',
    }),

    is_cashwait() {
      return this.user_payments.some(v => v.status == 5)
    },

    is_auto_payments() {
      return !!this.auto_payments.length
    },

    cashwaits() {
      if (this.user_payments.some(v => v.status == 5)) {
        return this.user_payments.filter(v => v.status == 5)
      } else { return [] }
    },

    color() {
      return !!this.user_type ?
        this.user_types[this.user_type].color : '#ffffff'
    },

    end_date() {
      return !!this.user_end_date ?
        this.toDatetimeLocal(new Date(this.user_end_date)).substr(0, 10) : null
    },

    date_diff() {
      return !!this.user_end_date ?
        this.getDDay(this.user_end_date) : 0
    },
  },

  async created() {
    try {
      await this.$store.dispatch('user/getUserInfo')
      await this.$store.dispatch('user/getMyAutoPayments')
    }
    catch(e) {
      this.$store.commit('error/setDialog', true)
      this.$store.commit('error/setErrorCode', e.response.status)
    }
    finally {
      // Get user image
      let has_img = this.$store.getters['user/has_img']
      if (!!has_img) {
        try {
          await this.$store.dispatch('user/getUserImage')
        } catch(e) {
          this.$store.commit('error/setDialog', true)
          this.$store.commit('error/setErrorCode', e.response.status)
        }
      } else {
        try {
          await this.$store.commit('user/removeUserImage')
        } catch(e) {
          this.$store.commit('error/setDialog', true)
          this.$store.commit('error/setErrorCode', e.response.status)
        }
      }
    }
  },

  watch: {
    user_type: {
      async handler(val) {
        if (val!= 'basic' && this.is_expired) {
          await this.$store.dispatch('auth/updateToken')
        }
      },
    },
  },

  methods: {
    toDatetimeLocal,
    getDDay,

    async logout() {
      await this.$store.dispatch('auth/logoutManually')
      this.$router.replace({ name: 'welcome' })
      location.reload()
    },

    gaClick(param) {
      this.$analytics.logEvent('click', { name: param })
    }
  }
}
</script>

<style scoped>
  .user-image {
    cursor: pointer;
    display: flex;
    align-items: center;
  }

  .user-image img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: solid 3px #dde2e5;
    object-fit: cover;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .menu {
    display: flex;
    flex-direction: row;
    padding-left: 3px;
  }

  .header-item .badge {
    position: relative;
    top: -15px;
    right: 0px;
  }

  .menu .badge {
    right: 3px;
  }

  .badge {
    position: relative;
    width: 5px;
    height: 5px;
    border-radius: 50%;
  }

  .meta {
    margin-bottom: 12px;
  }

  #no-image {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    padding: 13px;
    border: solid 3px #dde2e5;
    background-color: #fafafb;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  #no-image-icon {
    font-size: 24px;
    color: #bac2cc;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared_components/part/AccountMenu.vue